import './TacticalBackdrop.css'

/**
 * The ambient instrument backdrop.
 *
 * A fixed layer behind the whole console: a faint drifting phosphor grid, a slow
 * scanline and a top glow — the texture of an emissive display left running. It
 * is the one place the interface is allowed to be atmospheric rather than
 * informational, so every layer sits far below the contrast floor, is
 * `aria-hidden`, takes no pointer events, and (like all motion here) is stilled
 * by `prefers-reduced-motion`. It renders once, behind the shell.
 */
export function TacticalBackdrop() {
  return (
    <div className="k-backdrop" aria-hidden="true">
      <div className="k-backdrop__grid" />
      <div className="k-backdrop__glow" />
    </div>
  )
}
